'use strict';

var ChartLengthOfStayLegendController = function ChartLengthOfStayLegendController($scope) {
  var DEFAULT_PCT = {
    id: 'ALL',
    label: 'Select All'
  };
  $scope.pctLabels = [{
    id: 'ALL',
    label: 'Select All'
  }, {
    id: 'lte30pct',
    label: '0 - 30%'
  }, {
    id: 'lte60pct',
    label: '30 - 60%'
  }, {
    id: 'lte90pct',
    label: '60 - 90%'
  }, {
    id: 'gte90pct',
    label: '100%+'
  }];
  $scope.selectedPct = DEFAULT_PCT;
  $scope.onPctChange = function () {
    $scope.$emit('chart:lengthOfStay:fareChangePctFilterChanged', $scope.selectedPct.id);
  };
  $scope.$on('chart:lengthOfStay:fareChangePctReset', function () {
    $scope.selectedPct = DEFAULT_PCT;
  });
  $scope.displayServiceIdToFlights = function (displayServiceId) {
    return (displayServiceId || '').replace(/\|/g, '/');
  };
  $scope.resetChartHandler = function () {
    $scope.selectedPct = DEFAULT_PCT;
    $scope.$emit('chart:lengthOfStay:setInitialState');
  };
};
ChartLengthOfStayLegendController.$inject = ['$scope'];
module.exports = ChartLengthOfStayLegendController;